import config from '@bedrock-rdk/config';
import { request } from '@bedrock-rdk/utils';
import { HOME_PATH } from '../../../../routes/routes.utils';

const DEEPLINK_REGEX = /\/((video-tv\/(filme|serien|live-tv|shows|live)\/(\S+)-(\d+))|((podcast|musik)\/(\S+)))/gi;
const DEFAULT_PATH = HOME_PATH;

const VOD_PREFIX = 'clip_';

const redirect = path => {
  window.history.replaceState(null, document.title, `/${window.location.search}#${path}`);
};

const patchPath = path => {
  if (!path.startsWith('video/')) {
    return path;
  }

  const id = path.split('/').pop();

  return `video/${id.startsWith(VOD_PREFIX) ? id : `${VOD_PREFIX}${id}`}`;
};

export const handleDeeplink = async (pathname, callback) => {
  const path = pathname || document.location.pathname || '';

  if (path && path.match(DEEPLINK_REGEX)) {
    try {
      const { internalPaths: result } = await request(`${config.fido.baseUrlsByAPIType.linkConverter}/internal-paths`, {
        query: { 'external-path': path },
        responseType: 'json',
      });

      const deeplink = result.find(({ scopes }) => scopes.includes('rdk'));

      const handler = callback || redirect;
      handler(deeplink.path ? patchPath(deeplink.path) : DEFAULT_PATH);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[deeplink] Can not handle deeplink request, rerouting to the home screen');

      redirect(DEFAULT_PATH);
    }
  }
};
